import { render, staticRenderFns } from "./file-downloader.vue?vue&type=template&id=746a4d64&scoped=true&"
import script from "./file-downloader.vue?vue&type=script&lang=ts&"
export * from "./file-downloader.vue?vue&type=script&lang=ts&"
import style0 from "./file-downloader.vue?vue&type=style&index=0&id=746a4d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a4d64",
  null
  
)

export default component.exports